import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { ExecucaoOrcamentaria } from '../../models/execucao-orcamentaria.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ExecucaoOrcamentariaService } from '../../services/execucao-orcamentaria.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-execucao-orcamentaria-loa-new',
  templateUrl: './detalhe-projeto-execucao-orcamentaria-loa-new.component.html',
  styleUrls: ['./detalhe-projeto-execucao-orcamentaria-loa-new.component.scss']
})
export class DetalheProjetoExecucaoOrcamentariaLoaNewComponent extends BaseFormComponent<ExecucaoOrcamentaria> implements OnInit, OnDestroy {

  @Input() idExecucao: number;
  execucaoOrcamentariaId: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  filters: any;
  list: any;
  permission: any;
  checked: boolean;
  
  filteredData:any[];
  collumnOrder: string;
  direction:string;

  constructor(
    private myService: ExecucaoOrcamentariaService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.execucaoOrcamentariaId = this.activatedRoute.snapshot.params?.id;
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.permission = this.activatedRoute.snapshot.data['permission'];
      this.initForm();
      this.initFilters();
    });
    
    this.addSub(EventSharedService.get('reloadPermission').subscribe((res) => {
      this.permission = res;
    }));
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initFilters(event = false) {
    this.loading();
    let obj = {year: this.permission?.execucao_orcamentaria_year};
    if (event) {
      obj['projeto_loa'] = this.form.get('projeto_loa').value;
    }
    this.form.get("subprojeto").setValue(null);
    this.form.get("recurso").setValue(null);
    this.form.get("natureza_despesa").setValue(null);
    this.disableForm();
    this.addSub(
      this.myService.loaFpeFilters(obj).subscribe({
        next: (res) => {
          this.filters = res;
          if (event && this.form.get('projeto_loa').value) {
            this.form.get("subprojeto").enable();
            this.form.get("recurso").enable();
            this.form.get("natureza_despesa").enable();
          } else {
            this.form.get('projeto_loa').setValue(this.filters?.projeto_loa);
          }
          this.loaded();
        },
        error: (error) => {
          this.msgError(error?.error?.message);
          this.loaded();
        },
      })
    );
  }

  initForm() {
    this.form = new FormGroup({
      projeto_loa: new FormControl(null, [Validators.required]),
      subprojeto: new FormControl({ value: null, disabled: true }),
      recurso: new FormControl({ value: null, disabled: true }),
      natureza_despesa: new FormControl({ value: null, disabled: true }),
    });
  }

  getDataCreate() {
    let data;
    data = Object.assign({}, data, this.form.value);
    data.year = this.permission?.execucao_orcamentaria_year;
    return data;
  }

  cancelar() {
    this.cleanForm();
    EventSharedService.get('vinculo').emit(false);
  }

  cleanForm() {
    this.form.reset();
    this.disableForm();
  }

  disableForm() {
    this.form.get("subprojeto").disable();
    this.form.get("recurso").disable();
    this.form.get("natureza_despesa").disable();
    this.list = [];
    this.filteredData = [];
  }

  pesquisar() {
    if (this.form.valid) {
      if (this.idExecucao) {
        this.loading();
        let obj = this.getDataCreate();
        obj['year'] =  this.permission?.execucao_orcamentaria_year;
        this.addSub(
          this.myService.loaFpeSearch(obj).subscribe({
            next: (res) => {
              this.list = res;
              this.filteredData = this.list;
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  selectAll() {
    this.checked = !this.checked;
    this.list.forEach(item => item.checked = this.checked);
  }

  getDataCreateSalvar() {
    return {
      fpe: this.list.filter(item => item.checked),
      execucao_orcamentaria_id: this.execucaoOrcamentariaId
    };
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.idExecucao) {
        this.addSub(
          this.myService.loaFpeCreate(this.getDataCreateSalvar()).subscribe({
            next: (res) => {
              this.confirmation('Associação salva com sucesso!').subscribe(() => {
                EventSharedService.get('vinculo').emit(true);
                window.location.reload();
              });
              this.cleanForm();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }
  
  formatSubprojeto(item:any): string{
    const subprojeto = item?.subprojeto;
    const acao = item?.acao;
    var subprojetoFix = subprojeto == '01'? '00' : subprojeto;
    return subprojetoFix + acao;
  }

  orderData(column:string): void{
    if (column === this.collumnOrder) {
      this.direction = this.direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.direction = 'asc';
    }
    this.collumnOrder = column;

    const currentData = this.list;

    this.filteredData = [...currentData].sort((a, b) => {
      var valueA = a?.[column];
      var valueB = b?.[column];
      if(column == 'subprojeto'){
        valueA = this.formatSubprojeto(a);
        valueB = this.formatSubprojeto(b);
      }
      if (valueA == null) return 1;
      if (valueB == null) return -1;
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return this.direction === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }
      return this.direction === 'asc'
        ? (valueA > valueB ? 1 : -1)
        : (valueA < valueB ? 1 : -1);
    });
  }
}
